<template>
    <card class="form-horizontal">
        <div class="card-header">
            <h6 class="card-title text-center">
                Datos de solicitud
            </h6>
        </div>
        <div class="card-body">
            <div class="form-group">
                <label>Tipo de producto *</label>
                <fg-input   tabindex="0"
                            name="tipo de producto"
                            v-validate="modelValidations.requestData"
                            :error="getError('tipo de producto')"
                            v-model="requestProductType">
                        <el-select
                                @change="changeProductType()"
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="requestProductType">
                        <el-option v-for="productType in $store.getters.getProductTypes" :key="productType.id"
                                class="select-warning"
                                :value="productType.id"
                                :label="productType.name">
                        </el-option>
                    </el-select>
                </fg-input>
            </div>
            <div class="form-group">
                <label>Tipo de crédito *</label>
                <fg-input   tabindex="1"
                            name="tipo de crédito"
                            v-validate="modelValidations.requestData"
                            :error="getError('tipo de crédito')"
                            v-model="requestCreditType">
                        <el-select
                                :disabled="validateStudy"
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="requestCreditType">
                        <el-option v-for="creditType in $store.getters.getCreditTypes" :key="creditType.id"
                                class="select-warning"
                                :value="creditType.id"
                                :label="creditType.name">
                        </el-option>
                    </el-select>
                </fg-input>
            </div>
            <div v-if="pequenia_empresa" class="form-group">
                <label>Categoría del cliente *</label>
                <fg-input   tabindex="1"
                            name="tipo de cliente"
                            v-validate="modelValidations.requestData"
                            :error="getError('tipo de cliente')"
                            v-model="requestClientType">
                        <el-select
                                :disabled="isFirstStudy"
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="requestClientType">
                        <el-option v-for="clientType in $store.getters.getClientTypes" :key="clientType.id"
                                class="select-warning"
                                :value="clientType.id"
                                :label="clientType.name">
                        </el-option>
                    </el-select>
                </fg-input>
            </div>
            <div class="form-group">
                <label>Monto *</label>
                <vue-numeric  :max=999999999999999 :disabled="validateStudy" tabindex="2" currency="$" autocomplete="off" name="monto" v-validate="modelValidations.requestDataAmount" :error="getError('monto')" separator="." class="form-control" v-model="requestAmount"></vue-numeric>
            </div>
            <div class="form-group">
                <label>Destino del crédito *</label>
                <fg-input   tabindex="3"
                            name="destino del crédito"
                            v-validate="modelValidations.requestData"
                            :error="getError('destino del crédito')"
                            v-model="requestCreditPurpose">
                        <el-select
                                :disabled="validateStudy"
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="requestCreditPurpose">
                        <el-option v-for="creditPurpose in $store.getters.getCreditPurposes" :key="creditPurpose.id"
                                class="select-warning"
                                :value="creditPurpose.id"
                                :label="creditPurpose.name">
                        </el-option>
                    </el-select>
                </fg-input>
            </div>
            <div v-if="validateAgroMicro()" class="form-group">
                <label>Nombre de actividad *</label>
                <fg-input
                    type="text"
                    tabindex="6"
                    name="nombre de actividad"
                    autocomplete="off"
                    placeholder="nombre de actividad"
                    v-validate="{ required: validateAgroMicro(), max: 30 }"
                    :error="getError('nombre de actividad')"
                    v-model="customerPrincipalActivity"
                />
            </div>
            <div v-if="microcredit" class="form-group">
                <label>Tipo de actividad *</label>
                <fg-input   tabindex="4"
                            name="tipo de actividad"
                            v-validate="modelValidations.requestData"
                            :error="getError('tipo de actividad')"
                            v-model="customerStudyActivity">
                        <el-select
                                @change="changeActivityType()"
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="customerStudyActivity">
                        <el-option v-for="activityType in $store.getters.getActivityTypes" :key="activityType.id"
                                class="select-warning"
                                :value="activityType.id"
                                :label="activityType.name">
                        </el-option>
                    </el-select>
                </fg-input>
            </div>
            <div v-if="activity_type_computed == 'Comercio'" class="form-group">
                <label>Subcategoría *</label>
                <fg-input   tabindex="5"
                            name="subcategoría"
                            v-validate="modelValidations.requestData"
                            :error="getError('subcategoría')"
                            v-model="customerStudySubcategory">
                        <el-select
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="customerStudySubcategory">
                        <el-option
                                class="select-warning"
                                value="general"
                                label="Comercio general">
                        </el-option>
                        <el-option
                                class="select-warning"
                                value="catalogo"
                                label="Ventas por catálogo">
                        </el-option>
                    </el-select>
                </fg-input>
            </div>
            <div v-if="activity_type_computed == 'Servicios'" class="form-group">
                <label>Subcategoría *</label>
                <fg-input   tabindex="5"
                            name="subcategoría"
                            v-validate="modelValidations.requestData"
                            :error="getError('subcategoría')"
                            v-model="customerStudySubcategory">
                        <el-select
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="customerStudySubcategory">
                        <el-option
                                class="select-warning"
                                value="serviciogeneral"
                                label="Servicio general">
                        </el-option>
                        <el-option
                                class="select-warning"
                                value="transporte"
                                label="Servicio de transporte">
                        </el-option>
                    </el-select>
                </fg-input>
            </div>
            <div v-if="agro" class="form-group">
                <label>Actividad principal</label>
                <fg-input
                    type="text"
                    tabindex="6"
                    name="actividad principal"
                    autocomplete="off"
                    placeholder="describa la actividad principal"
                    v-validate="validationAgroRules"
                    :error="getError('actividad principal')"
                    v-model="customerPrincipalActivity"
                />
            </div>

            <div class="form-group">
                <label>Descripción del negocio </label>
                <textarea   class="form-control"
                            tabindex="7"
                            type="text"
                            name="descripción"
                            autocomplete="off"
                            placeholder="describa el negocio"
                            v-validate="dynamicValidationRule"
                            :error="getError('descripción')"
                            v-model="customerStudyDescription">
                </textarea>
                <span v-show="errors.has('descripción')" class="text-danger" style="font-size: 11px;">
                    {{ errors.first('descripción') }}
                </span>
            </div>
            <div v-if="consumer" class="form-group">
                <label>Salario</label>
                <vue-numeric  :max=999999999999999 tabindex="7" currency="$" autocomplete="off" name="salario" v-validate="modelValidations.requestDataAmount" :error="getError('salario')" separator="." class="form-control" v-model="customerNetSalary"></vue-numeric>
            </div>
            <div v-if="consumer" class="form-group">
                <label>Salario básico</label>
                <vue-numeric  :max=999999999999999 tabindex="7" currency="$" autocomplete="off" name="salario" v-validate="modelValidations.customerSalary" :error="getError('salario')" separator="." class="form-control" v-model="customerSalary"></vue-numeric>
            </div>
            <div v-show="consumer" class="form-group">
                <label>Prestaciones </label>
                <fg-input   tabindex="7"
                            name="prestaciones"
                            >
                        <el-select
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="validateSalary">
                        <el-option
                                class="select-warning"
                                :value="false"
                                label="No">
                        </el-option>
                        <el-option
                                class="select-warning"
                                :value="true"
                                label="Si">
                        </el-option>
                    </el-select>
                </fg-input>
            </div>
            <div v-if="consumer && validateSalary" class="row">
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.layoffs">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch>
                        <label class="ml-2">Cesantías</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.layoffsInterest">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch>
                        <label class="ml-2">Interés cesantías</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.extraPayment">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch>
                        <label class="ml-2">Prima</label>
                    </div>
            </div>
            <div v-if="consumer && validateSalary" class="alert alert-warning mt-2">
                <span>Cesantías: {{setFormat(layoffsDaysValue)}}</span>
            </div>
            <div v-if="consumer && validateSalary" class="alert alert-warning mt-2">
                <span>Interés cesantías: {{setFormat(interestLayoffsDaysValue)}}</span>
            </div>
            <div v-if="consumer && validateSalary" class="alert alert-warning mt-2">
                <span>prima: {{setFormat(extraPaymentDaysValue)}}</span>
            </div>
            <!-- <div v-if="activity_type_computed == 'PRODUCCIÓN'" class="form-group">
                <label>Subcategoría *</label>
                <fg-input   name="subcategoría"
                            v-validate="modelValidations.requestData"
                            :error="getError('subcategoría')"
                            v-model="customerStudySubcategory">
                        <el-select
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="customerStudySubcategory">
                        <el-option
                                class="select-warning"
                                value="produccion"
                                label="Producción">
                        </el-option>
                    </el-select>
                </fg-input>
            </div> -->
        </div>
        <div class="card-footer">
            <div class="text-right">
                <p-button @click="toSalesCostsSelection()" type="warning">Siguiente</p-button>
                <p-button @click="toPersonalData()" type="default" class="pull-left mb-3">Atrás</p-button>
            </div>
        </div>
    </card>
</template>
    <script>
    import { Card } from 'src/components/UIComponents'
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import {Select, Option} from 'element-ui'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import moment from 'moment'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import { parse } from 'expression-eval'
    import { Validator } from "vee-validate";

    Validator.extend("no_emojis", {
        getMessage: field => `El campo ${field} no puede contener emojis.`,
        validate: value => {
            // Expresión regular para detectar emojis más robusta
            const emojiRegex = /[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{1F1E6}-\u{1F1FF}|\u{1F201}-\u{1F251}|\u{1F004}|\u{1F0CF}|\u{1F18E}|\u{1F191}-\u{1F19A}|\u{1F21A}|\u{1F22F}|\u{1F232}-\u{1F236}|\u{1F238}-\u{1F23A}|\u{1F250}-\u{1F251}]/u;
            return !emojiRegex.test(value);
        }
    });

    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            VueNumeric,
            PSwitch,
        },
        data() {
        return {
            validateSalary: false,
            layoffsDays: 0,
            extraPaymentDays: 0,
            consumer: false,
            microcredit: false,
            pequenia_empresa: false,
            agro: false,
            username: '',
            password: '',
            auth_system: '',
            subcategory: '',
            amount: '',
            switches: {
                layoffs: true, //Cruce de ventas diario
                layoffsInterest: true, //Cruce de ventas semanal
                extraPayment: true, //Cruce de ventas mensual
            },
            modelValidations: {
                username: {
                    alpha_dash: true,
                    required: true,
                    max: 32
                },
                customerStudyDescription: {
                    required: false,
                    no_emojis: true,
                    max: 1024
                },
                customerStudyDescriptionAgro: {
                    required: true,
                    no_emojis: true,
                    max: 1024
                },
                customerPrincipalActivity: {
                    required: false,
                    max: 30
                },
                requestDataAmount: {
                    required: true
                },
                customerSalary: {
                    required: true
                },
                requestData: {
                    required: true
                }
            },
        }
        },
        watch: {
            'switches.layoffs': function(newVal) {
                if (this.switches.layoffs) {
                    var varLayoffsDaysValue = (parseFloat(this.customerSalary)* this.layoffsDays)/360;
                }
                else {
                    var varLayoffsDaysValue = 0;
                }
                if (this.switches.layoffsInterest) {
                    var varInterestLayoffsDaysValue = (varLayoffsDaysValue* this.layoffsDays * 0.12)/360;
                }
                else {
                    var varInterestLayoffsDaysValue = 0;
                }
                if (this.switches.extraPayment) {
                    var varExtraPaymentDaysValue = (parseFloat(this.customerSalary)* this.extraPaymentDays)/360;
                }
                else {
                    var varExtraPaymentDaysValue = 0;
                }
                var payload = {};
                payload.salary = this.customerSalary;
                payload.layoffs = parseFloat(varLayoffsDaysValue.toFixed(2));
                payload.interestLayoffs = parseFloat(varInterestLayoffsDaysValue.toFixed(2));
                payload.extraPayment = parseFloat(varExtraPaymentDaysValue.toFixed(2));
                this.$store.commit('updateCustomerSalary', payload)
            },
            'switches.layoffsInterest': function(newVal) {
                if (this.switches.layoffs) {
                    var varLayoffsDaysValue = (parseFloat(this.customerSalary)* this.layoffsDays)/360;
                }
                else {
                    var varLayoffsDaysValue = 0;
                }
                if (this.switches.layoffsInterest) {
                    var varInterestLayoffsDaysValue = (varLayoffsDaysValue* this.layoffsDays * 0.12)/360;
                }
                else {
                    var varInterestLayoffsDaysValue = 0;
                }
                if (this.switches.extraPayment) {
                    var varExtraPaymentDaysValue = (parseFloat(this.customerSalary)* this.extraPaymentDays)/360;
                }
                else {
                    var varExtraPaymentDaysValue = 0;
                }
                var payload = {};
                payload.salary = this.customerSalary;
                payload.layoffs = parseFloat(varLayoffsDaysValue.toFixed(2));
                payload.interestLayoffs = parseFloat(varInterestLayoffsDaysValue.toFixed(2));
                payload.extraPayment = parseFloat(varExtraPaymentDaysValue.toFixed(2));
                this.$store.commit('updateCustomerSalary', payload)
            },
            'switches.extraPayment': function(newVal) {
                if (this.switches.layoffs) {
                    var varLayoffsDaysValue = (parseFloat(this.customerSalary)* this.layoffsDays)/360;
                }
                else {
                    var varLayoffsDaysValue = 0;
                }
                if (this.switches.layoffsInterest) {
                    var varInterestLayoffsDaysValue = (varLayoffsDaysValue* this.layoffsDays * 0.12)/360;
                }
                else {
                    var varInterestLayoffsDaysValue = 0;
                }
                if (this.switches.extraPayment) {
                    var varExtraPaymentDaysValue = (parseFloat(this.customerSalary)* this.extraPaymentDays)/360;
                }
                else {
                    var varExtraPaymentDaysValue = 0;
                }
                var payload = {};
                payload.salary = this.customerSalary;
                payload.layoffs = parseFloat(varLayoffsDaysValue.toFixed(2));
                payload.interestLayoffs = parseFloat(varInterestLayoffsDaysValue.toFixed(2));
                payload.extraPayment = parseFloat(varExtraPaymentDaysValue.toFixed(2));
                this.$store.commit('updateCustomerSalary', payload)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            requestProductType: function(newVal, oldVal) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == newVal)
                this.productValidator(product);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateSalary: function(newVal, oldVal) {
                if (newVal) {
                    if (this.switches.layoffs) {
                        var varLayoffsDaysValue = (parseFloat(this.customerSalary)* this.layoffsDays)/360;
                    }
                    else {
                        var varLayoffsDaysValue = 0;
                    }
                    if (this.switches.layoffsInterest) {
                        var varInterestLayoffsDaysValue = (varLayoffsDaysValue* this.layoffsDays * 0.12)/360;
                    }
                    else {
                        var varInterestLayoffsDaysValue = 0;
                    }
                    if (this.switches.extraPayment) {
                        var varExtraPaymentDaysValue = (parseFloat(this.customerSalary)* this.extraPaymentDays)/360;
                    }
                    else {
                        var varExtraPaymentDaysValue = 0;
                    }
                    var payload = {};
                    payload.salary = this.customerSalary;
                    payload.layoffs = parseFloat(varLayoffsDaysValue.toFixed(2));
                    payload.interestLayoffs = parseFloat(varInterestLayoffsDaysValue.toFixed(2));
                    payload.extraPayment = parseFloat(varExtraPaymentDaysValue.toFixed(2));
                    this.$store.commit('updateCustomerSalary', payload)
                }
                else {
                    var payload = {};
                    payload.salary = this.customerSalary;
                    payload.layoffs = 0;
                    payload.interestLayoffs = 0;
                    payload.extraPayment = 0;
                    this.$store.commit('updateCustomerSalary', payload)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            customerStudySubcategory: function (newVal, oldVal) {
                if(newVal != oldVal) {
                    this.$store.dispatch('resetSalesCosts');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            subcategory: function (val) {
                this.$store.dispatch('setActivityTypeSubcategory',val);
            }
        },
        computed: {
            validationAgroRules() {
               return this.agro ? 'required|max:20' : 'max:20';
            },
            dynamicValidationRule() {
                return this.agro
                    ? this.modelValidations.customerStudyDescriptionAgro
                    : this.modelValidations.customerStudyDescription;
            },
            customerNetSalary: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].netSalary;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].netSalary;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].netSalary;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerNetSalary', val)
                }
            },
            customerSalary: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salary;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].salary;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].salary;
                    }
                },
                set: function (val) {
                    if (this.validateSalary) {
                        if (this.switches.layoffs) {
                            var varLayoffsDaysValue = (parseFloat(val)* this.layoffsDays)/360;
                        }
                        else {
                            var varLayoffsDaysValue = 0;
                        }
                        if (this.switches.layoffsInterest) {
                            var varInterestLayoffsDaysValue = (varLayoffsDaysValue* this.layoffsDays * 0.12)/360;
                        }
                        else {
                            var varInterestLayoffsDaysValue = 0;
                        }
                        if (this.switches.extraPayment) {
                            var varExtraPaymentDaysValue = (parseFloat(val)* this.extraPaymentDays)/360;
                        }
                        else {
                            var varExtraPaymentDaysValue = 0;
                        }
                        // var varLayoffsDaysValue = (parseFloat(val)* this.layoffsDays)/360;
                        // var varInterestLayoffsDaysValue = (varLayoffsDaysValue* this.layoffsDays * 0.12)/360;
                        // var varExtraPaymentDaysValue = (parseFloat(val)* this.extraPaymentDays)/360;
                        var payload = {};
                        payload.salary = val;
                        payload.layoffs = parseFloat(varLayoffsDaysValue.toFixed(2));
                        payload.interestLayoffs = parseFloat(varInterestLayoffsDaysValue.toFixed(2));
                        payload.extraPayment = parseFloat(varExtraPaymentDaysValue.toFixed(2));
                        this.$store.commit('updateCustomerSalary', payload)
                    }
                    else {
                        var payload = {};
                        payload.salary = val;
                        payload.layoffs = 0;
                        payload.interestLayoffs = 0;
                        payload.extraPayment = 0;
                        this.$store.commit('updateCustomerSalary', payload)
                    }
                }
            },
            layoffsDaysValue: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].layoffs;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].layoffs;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].layoffs;
                    }
                }
            },
            interestLayoffsDaysValue: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].interestLayoffs;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].interestLayoffs;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].interestLayoffs;
                    }
                }
            },
            extraPaymentDaysValue: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].extraPayment;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].extraPayment;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].extraPayment;
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             isFirstStudy: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                            return false
                        }
                        else {
                            return true
                        }
                    }
                    else if(this.$store.state.isSpouse) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy == 0) {
                            return false
                        }
                        else {
                            return true
                        }
                    }
                    else if(this.$store.state.isGuarantor) {
                        if ((this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1) == 0) {
                            return false
                        }
                        else {
                            return true
                        }
                    }
                },
                set: function() {
                    if (this.$store.state.isCustomer) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                            return false
                        }
                        else {
                            return true
                        }
                    }
                    else if(this.$store.state.isSpouse) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy == 0) {
                            return false
                        }
                        else {
                            return true
                        }
                    }
                    else if(this.$store.state.isGuarantor) {
                        if ((this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1) == 0) {
                            return false
                        }
                        else {
                            return true
                        }
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateStudy: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                            return false
                        }
                        else {
                            return true
                        }
                    }
                    else if(this.$store.state.isSpouse) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy == 0) {
                            return true
                        }
                        else {
                            return true
                        }
                    }
                    else if(this.$store.state.isGuarantor) {
                        if ((this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1) == 0) {
                            return true
                        }
                        else {
                            return true
                        }
                    }
                },
                set: function() {
                    if (this.$store.state.isCustomer) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                            return false
                        }
                        else {
                            return true
                        }
                    }
                    else if(this.$store.state.isSpouse) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy == 0) {
                            return false
                        }
                        else {
                            return true
                        }
                    }
                    else if(this.$store.state.isGuarantor) {
                        if ((this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1) == 0) {
                            return false
                        }
                        else {
                            return true
                        }
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            requestAmount: {
                get: function() {
                    return this.$store.state.assesments[this.$store.state.actualAssesment].amount;
                },
                set: function(val) {
                    this.$store.commit('updateRequestAmount', val)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            requestProductType: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType;
                    }
                    else {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType;
                    }
                },
                set: function(val) {
                    if (this.$store.state.isCustomer) {
                        const countStudies = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies.length;
                        if(countStudies > 1){
                            var firstProduct = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                            if(firstProduct.name.toLowerCase() == 'pequeña empresa'){
                                var product = this.$store.getters.getProductTypes.find(product => product.id == val)
                                if(product.name.toLowerCase() != 'pequeña empresa'){
                                    this.showNotificationError('Solo puedes agregar Pequeña empresa');
                                    return
                                }
                            }
                            else if(firstProduct.name.toLowerCase() == 'agropecuario'){
                                var product = this.$store.getters.getProductTypes.find(product => product.id == val)
                                if(product.name.toLowerCase() == 'pequeña empresa' || product.name.toLowerCase() == 'agropecuario' || product.name.toLowerCase() == 'microcrédito rural' || product.name.toLowerCase() == 'consumo'){
                                    this.showNotificationError('Solo puedes agregar microcrédito');
                                    return
                                }
                            }
                            else {
                                var product = this.$store.getters.getProductTypes.find(product => product.id == val)
                                if(product.name.toLowerCase() == 'pequeña empresa'){
                                    this.showNotificationError('No es permitido pequeña empresa como segundo estudio');
                                    return
                                }
                                else if(product.name.toLowerCase() == 'agropecuario'){
                                    this.showNotificationError('No es permitido agropecuario como segundo estudio');
                                    return
                                }
                            }
                        }
                        var product = this.$store.getters.getProductTypes.find(product => product.id == val)
                        if(product.name.toLowerCase() == 'microcrédito rural' || product.name.toLowerCase() == 'agropecuario'){
                            this.showNotificationError('Producto no implementado');
                            return
                        }
                    }
                    else if(this.$store.state.isSpouse) {
                        const countStudies = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies.length;
                        if(countStudies > 1){
                            this.showNotificationError('No es permitido un segundo estudio para cónyuge');
                            return
                        }
                        else if (countStudies == 1){
                            var firstProduct = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                            if(firstProduct.name.toLowerCase() == 'pequeña empresa'){
                                var product = this.$store.getters.getProductTypes.find(product => product.id == val)
                                if(product.name.toLowerCase() != 'pequeña empresa'){
                                    this.showNotificationError('Solo puedes agregar Pequeña empresa');
                                    return
                                }
                            }
                            else if(firstProduct.name.toLowerCase() == 'agropecuario') {
                                var product = this.$store.getters.getProductTypes.find(product => product.id == val)
                                if(product.name.toLowerCase() == 'pequeña empresa' || product.name.toLowerCase() == 'microcrédito rural' || product.name.toLowerCase() == 'agropecuario'){
                                    this.showNotificationError('Solo puedes agregar microcrédito o consumo');
                                    return
                                }
                            }

                        }
                    }
                    else if(this.$store.state.isGuarantor) {
                        const countStudies = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length;
                        if(countStudies > 1){
                            var firstProduct = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[0].productType)
                            if(firstProduct.name.toLowerCase() == 'pequeña empresa'){
                                var product = this.$store.getters.getProductTypes.find(product => product.id == val)
                                if(product.name.toLowerCase() != 'pequeña empresa'){
                                    this.showNotificationError('Solo puedes agregar Pequeña empresa');
                                    return
                                }
                            }
                            else {
                                var product = this.$store.getters.getProductTypes.find(product => product.id == val)
                                if(product.name.toLowerCase() == 'pequeña empresa'){
                                    this.showNotificationError('No es permitido pequeña empresa como segundo estudio');
                                    return
                                }
                            }
                        }
                        else {
                            var product = this.$store.getters.getProductTypes.find(product => product.id == val)
                            if(product.name.toLowerCase() == 'microcrédito rural' || product.name.toLowerCase() == 'agropecuario'){
                                this.showNotificationError('Producto no implementado');
                                return
                            }
                        }
                    }
                    this.$store.commit('updateRequestProductType', val)


                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            requestCreditType: {
                get: function() {
                    return this.$store.state.assesments[this.$store.state.actualAssesment].creditType;
                },
                set: function(val) {
                    this.$store.commit('updateRequestCreditType', val)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             requestClientType: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies.length > 1){
                            return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].clientType;
                        }
                        else {
                            return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].clientType;
                        }
                    }
                    else if(this.$store.state.isSpouse) {
                        if(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies.length > 1){
                            return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].clientType;
                        }
                        else {
                            return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].clientType;
                        }
                    }
                    else if(this.$store.state.isGuarantor) {
                        if(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length > 1){
                            return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[0].clientType;
                        }
                        else {
                            return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].clientType;
                        }
                    }
                    else {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].clientType;
                    }
                    // return this.$store.state.assesments[this.$store.state.actualAssesment].clientType;
                },
                set: function(val) {
                    this.$store.commit('updateRequestClientType', val)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            requestCreditPurpose: {
                get: function() {
                    return this.$store.state.assesments[this.$store.state.actualAssesment].creditPurpose;
                },
                set: function(val) {
                    if (this.consumer) {
                        var purpose = this.$store.getters.getCreditPurposes.find(purpose => purpose.id == val)
                        if (purpose.name.toLowerCase() != 'libre inversion' && purpose.name.toLowerCase() != 'libre inversión') {
                            this.showNotificationError('Este destino de crédito no es válido para consumo')
                        }
                        else if (purpose.name.toLowerCase() == 'libre inversion' || purpose.name.toLowerCase() == 'libre inversión') {
                            this.$store.commit('updateRequestCreditPurpose', val)
                        }
                    }
                    else {
                        this.$store.commit('updateRequestCreditPurpose', val)
                    }

                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            customerStudyActivity: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studyActivity;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studyActivity;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studyActivity;
                    }
                },
                set: function(val) {
                    this.$store.commit('updateRequestStudyActivity', val)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            customerStudySubcategory: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                    }
                },
                set: function(val) {
                    this.$store.commit('updateRequestStudySubcategory', val)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             customerPrincipalActivity: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].principalActivity;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].principalActivity;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].principalActivity;
                    }
                },
                set: function(val) {
                    this.$store.commit('updateRequestPrincipalActivity', val)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            customerStudyDescription: {
                get: function() {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].activityDescription;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].activityDescription;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].activityDescription;
                    }
                },
                set: function(val) {
                    if(val.length <= 1024) {
                        this.$store.commit('updateRequestStudyDescription', val)
                    }
                    else {
                        this.$store.commit('updateRequestStudyDescription', val.substr(0,1024))
                        this.$forceUpdate()
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            activity_type_computed ()  {
                if (this.$store.state.isCustomer) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studyActivity) {
                        var activity = this.$store.getters.getActivityTypes.find(activity => activity.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studyActivity)
                        return activity.name;
                    }
                    else {
                        return ''
                    }
                }
                else if(this.$store.state.isSpouse) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studyActivity) {
                        var activity = this.$store.getters.getActivityTypes.find(activity => activity.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studyActivity)
                        return activity.name;
                    }
                    else {
                        return ''
                    }
                }
                else if(this.$store.state.isGuarantor) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studyActivity) {
                        var activity = this.$store.getters.getActivityTypes.find(activity => activity.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studyActivity)
                        return activity.name;
                    }
                    else {
                        return ''
                    }
                }
            }
        },
        methods: {
            validateAgroMicro () {
                if (this.$store.state.isCustomer) {
                    const countStudies = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies.length;
                    if(countStudies > 1){
                        var firstProduct = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                        if(firstProduct.name.toLowerCase() == 'agropecuario'){
                            if (this.requestProductType !== null) {
                                var product = this.$store.getters.getProductTypes.find(product => product.id == this.requestProductType);
                                if (product && product.name.toLowerCase() === 'microcrédito') {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                            else {
                                return true;
                            }

                        }
                        else {
                            return false
                        }

                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            consumerDays () {
                var firstDayYear = moment().startOf('year');
                var firstDaySecondSemester = moment(firstDayYear.year()+'-07-01');
                var now = moment();
                // var now = moment('2020-07-02');
                var layoffsDays = now.diff(firstDayYear,'days');
                if (now.isBefore(firstDaySecondSemester)) {
                    var extraPaymentDays = now.diff(firstDayYear,'days');
                }
                else {
                    var extraPaymentDays = now.diff(firstDaySecondSemester,'days');
                }
                this.layoffsDays = layoffsDays;
                this.extraPaymentDays = extraPaymentDays;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (product.name.toLowerCase() == 'consumo') {
                    this.consumer = true;
                    this.microcredit = false;
                    this.pequenia_empresa = false;
                    this.agro = false;
                    this.customerStudyActivity = '';
                    this.customerStudySubcategory = '';
                    if (this.$store.state.isCustomer) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                            var purpose = this.$store.getters.getCreditPurposes.find(purpose => purpose.name.toLowerCase() == 'libre inversión' || purpose.name.toLowerCase() == 'libre inversion');
                            this.requestCreditPurpose = purpose.id;
                        }
                    }
                }
                else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                    this.microcredit = true;
                    this.consumer = false;
                    this.pequenia_empresa = false;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.pequenia_empresa = true;
                    this.microcredit = true;
                    this.consumer = false;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'agropecuario') {
                    this.pequenia_empresa = false;
                    this.microcredit = false;
                    this.consumer = false;
                    this.agro = true;
                }

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            changeActivityType () {
                let activity = this.$store.getters.getActivityTypes.find((tableRow) => tableRow.id === this.customerStudyActivity);
                if (activity.name == 'Producción') {
                    this.customerStudySubcategory = 'produccion';
                }
                this.$store.dispatch('resetSalesCosts');
                this.$store.dispatch('resetBalance');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            changeProductType () {
                this.$store.dispatch('resetBalance');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /***
            * Función para mostrar un mensaje de éxito
            */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toPersonalData () {
                this.$router.push('/asessments/new_asessment/customer/personal_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].amount == 0) {
                            this.showNotificationError('El monto a solicitar no puede ser 0');
                            return
                        }
                        var payload = {
                            stage: 'Ingreso de datos de negocio',
                            description: 'Se ingresan los datos del negocio.',
                            dateTime: moment().format()
                        };
                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                            var vm = this;
                            if (vm.$store.state.isCustomer) {
                                if(!vm.agro){
                                    swal({
                                        title: '¿Deseas agregar información al FM100?',
                                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                        text: 'Si aceptas, podrás agregar o editar la información del formulario FM100',
                                        type: 'info',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        vm.$router.push('/asessments/new_asessment/customer/fm100');
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        if (dismiss == 'cancel') {
                                            if (vm.$store.state.isCustomer) {
                                                var subcategory = vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.studies[vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                            }
                                            else if(vm.$store.state.isSpouse) {
                                                var subcategory = vm.$store.state.assesments[vm.$store.state.actualAssesment].customerSpouse.studies[vm.$store.state.assesments[vm.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                            }
                                            if (vm.microcredit) {
                                                if (subcategory == 'catalogo') {
                                                    // vm.showNotificationSuccess('El formulario FM100 y FM102 ya están disponibles en el menú de la evaluación');
                                                    vm.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                                                }
                                                else {
                                                    // vm.showNotificationSuccess('El formulario FM100 y FM102 ya están disponibles en el menú de la evaluación');
                                                    vm.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                                }
                                            }
                                            else if(vm.consumer) {
                                                // vm.showNotificationSuccess('El formulario FM100 y FM102 ya están disponibles en el menú de la evaluación');
                                                vm.$router.push('/asessments/new_asessment/customer/others/business_references');
                                            }
                                            else if(vm.agro){
                                                vm.$router.push('/asessments/new_asessment/customer/cash_flow');
                                            }
                                        }
                                        else {
                                            swal({
                                                title: 'Cancelado',
                                                text: 'El analista no ha continuado',
                                                type: 'error',
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                buttonsStyling: false
                                            })
                                        }
                                    })
                                }
                                else {
                                    vm.$router.push('/asessments/new_asessment/customer/cash_flow');
                                }
                            }
                            else if (vm.$store.state.isSpouse) {
                                if (vm.$store.state.isCustomer) {
                                    var subcategory = vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.studies[vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                }
                                else if(vm.$store.state.isSpouse) {
                                    var subcategory = vm.$store.state.assesments[vm.$store.state.actualAssesment].customerSpouse.studies[vm.$store.state.assesments[vm.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                }
                                if (vm.microcredit) {
                                    if (subcategory == 'catalogo') {
                                        // vm.showNotificationSuccess('El formulario FM100 y FM102 ya están disponibles en el menú de la evaluación');
                                        vm.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                                    }
                                    else {
                                        // vm.showNotificationSuccess('El formulario FM100 y FM102 ya están disponibles en el menú de la evaluación');
                                        vm.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                    }
                                }
                                else if(vm.consumer) {
                                    // vm.showNotificationSuccess('El formulario FM100 y FM102 ya están disponibles en el menú de la evaluación');
                                    vm.$router.push('/asessments/new_asessment/customer/others/business_references');
                                }
                                else if(vm.agro){
                                    vm.$router.push('/asessments/new_asessment/customer/cash_flow');
                                }
                            }
                            else if (vm.$store.state.isGuarantor) {
                                if(!vm.agro){
                                    swal({
                                        title: '¿Deseas agregar información al FM100?',
                                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                        text: 'Si aceptas, podrás agregar o editar la información del formulario FM100 del codeudor',
                                        type: 'info',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        vm.$router.push('/asessments/new_asessment/customer/fm100');
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        if (dismiss == 'cancel') {
                                            if (vm.$store.state.isCustomer) {
                                                var subcategory = vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.studies[vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                            }
                                            else if(vm.$store.state.isSpouse) {
                                                var subcategory = vm.$store.state.assesments[vm.$store.state.actualAssesment].customerSpouse.studies[vm.$store.state.assesments[vm.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                            }
                                            else if(vm.$store.state.isGuarantor) {
                                                var subcategory = vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[vm.$store.state.assesments[vm.$store.state.actualAssesment].actualGuarantors].studies[vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[vm.$store.state.assesments[vm.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                            }
                                            if (vm.microcredit) {
                                                if (subcategory == 'catalogo') {
                                                    // vm.showNotificationSuccess('El formulario FM100 y FM102 ya están disponibles en el menú de la evaluación');
                                                    vm.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                                                }
                                                else {
                                                    // vm.showNotificationSuccess('El formulario FM100 y FM102 ya están disponibles en el menú de la evaluación');
                                                    vm.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                                }
                                            }
                                            else if(vm.consumer) {
                                                // vm.showNotificationSuccess('El formulario FM100 y FM102 ya están disponibles en el menú de la evaluación');
                                                vm.$router.push('/asessments/new_asessment/customer/others/business_references');
                                            }
                                            else if(vm.agro){
                                                vm.$router.push('/asessments/new_asessment/customer/cash_flow');
                                            }
                                        }
                                        else {
                                            swal({
                                                title: 'Cancelado',
                                                text: 'El analista no ha continuado',
                                                type: 'error',
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                buttonsStyling: false
                                            })
                                        }
                                    })
                                }
                                else {
                                    vm.$router.push('/asessments/new_asessment/customer/cash_flow');
                                }
                            }
                        });
                    }
                    else {
                            console.error('Error: Campos no diligenciados correctamente');
                            console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                            this.errors.items.forEach(error => {
                                console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                            });
                            this.showNotificationError('Campos no diligenciados correctamente');
                        }
                })


            }
        },
        mounted() {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)
                    this.productValidator(product);
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].layoffs != 0 || this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].interestLayoffs != 0 || this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].extraPayment != 0) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].layoffs != 0) {
                        this.switches.layoffs = true;
                    }
                    else {
                        this.switches.layoffs = false;
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].interestLayoffs != 0) {
                        this.switches.layoffsInterest = true;
                    }
                    else {
                        this.switches.layoffsInterest = false;
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].extraPayment != 0) {
                        this.switches.extraPayment = true;
                    }
                    else {
                        this.switches.extraPayment = false;
                    }
                    this.validateSalary = true;
                }
                this.consumerDays();
            }
            else if (this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType)
                    this.productValidator(product);
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].layoffs != 0 || this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].interestLayoffs != 0 || this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].extraPayment != 0) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].layoffs != 0) {
                        this.switches.layoffs = true;
                    }
                    else {
                        this.switches.layoffs = false;
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].interestLayoffs != 0) {
                        this.switches.layoffsInterest = true;
                    }
                    else {
                        this.switches.layoffsInterest = false;
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].extraPayment != 0) {
                        this.switches.extraPayment = true;
                    }
                    else {
                        this.switches.extraPayment = false;
                    }
                    this.validateSalary = true;
                }
                this.consumerDays();
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType)
                    this.productValidator(product);
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].layoffs != 0 || this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].interestLayoffs != 0 || this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].extraPayment != 0) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].layoffs != 0) {
                        this.switches.layoffs = true;
                    }
                    else {
                        this.switches.layoffs = false;
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].interestLayoffs != 0) {
                        this.switches.layoffsInterest = true;
                    }
                    else {
                        this.switches.layoffsInterest = false;
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].extraPayment != 0) {
                        this.switches.extraPayment = true;
                    }
                    else {
                        this.switches.extraPayment = false;
                    }
                    this.validateSalary = true;
                }
                this.consumerDays();
            }
            // this.$validator.extend('smaller', {
            //     getMessage: field => 'El valor no es menor al salario neto',
            //     validate: value => new Promise((resolve, reject) => {
            //         setTimeout(() => {
            //             resolve({
            //                 valid: value < this.customerNetSalary
            //         }, 500);
            //     });
            //     })
            // });
        }
    }
</script>
<style>
</style>
